module.exports = __webpack_public_path__ + "a6d5c8ed2c6aaf587b48744ada7686ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/presentation.png
// module id = 1051
// module chunks = 0